export const figure18e = {
  chart: {
      type: 'line',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: 230,
      plotBackgroundColor: null,
      plotBorderWidth: null,
    },
    credits: {
      enabled: false
  },
    title: {
      text: 'Nigéria'
    },
    subtitle: {
      text: null
  },
    xAxis: {
      categories: ['2013','2016','2019']
    },
    labels: {
      	style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    yAxis: {
      min: 0,
      max: 4000,
      tickInterval: 1000,
      title: {
          text: null,
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false
        },
        enableMouseTracking: true
      }
    },
    legend: {
      enabled: false,
  },
    colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
    series: [{
      name: 'Petites exploitations',
      data: [969.75, 504.35, 477.36, ]
    }, {
      name: 'Autres exploitations',
      data: [2904.55, 1442.7, 1597.68, ]
    },{
      name: 'Petites exploitations dirigées par une femme',
      data: [598.98, 374.81, 278.13, ]
    },{
      name: 'Petites exploitations dirigées par un homme',
      data: [1048.72, 531.4, 522.85]
    }]
  }

  